import ConnectedAccounts from 'containers/connected_accounts';
import GiftCardOnboardStartPage from 'containers/gift_card_onboarding/start_page';
import RedirectToMyConnectedAccounts from 'containers/redirects/RedirectToMyConnectedAccounts';
import { lazyRetry } from 'features/router';
import { HighlightPage } from 'pages/HighlightPage';
import { RecommendStylePage } from 'pages/RecommendStylePage';
import ViewRelatedStyles from 'pages/RelatedStylesPage';
import { SearchStylePage } from 'pages/SearchStylePage';
import { SearchStylistPage } from 'pages/SearchStylistPage';
import { lazy } from 'react';
import { PATH } from './constant';
import config from 'config';
import RedirectToStyleRequests from 'containers/redirects/RedirectToStyleRequests';
import { SESSION_QUIZ_PATH } from 'containers/session_quiz/constants';

const QuizManager = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/index'), 'containers/quiz_manager/index'),
);
const ForgotPass = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/forgot_password/ForgotPass'),
        'containers/authentication/forgot_password/ForgotPass',
    ),
);
const ResetPasswordSuccess = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/forgot_password/reset_password_success'),
        'containers/authentication/forgot_password/reset_password_success',
    ),
);
const Login = lazy(() =>
    lazyRetry(() => import('containers/authentication/Login/Login'), 'containers/authentication/Login/Login'),
);
const Logout = lazy(() =>
    lazyRetry(() => import('containers/authentication/Logout/index'), 'containers/authentication/Logout/index'),
);
const Widget = lazy(() => lazyRetry(() => import('containers/widget/widget_local'), 'containers/widget/widget_local'));
const LoginWithEmail = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/Login/LoginWithEmail'),
        'containers/authentication/Login/LoginWithEmail',
    ),
);
const AdditionalSignupDetails = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/SignUp/AdditionalSignupDetails'),
        'containers/authentication/SignUp/AdditionalSignupDetails',
    ),
);
const BecomeACustomer = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/SignUp/become_a_customer'),
        'containers/authentication/SignUp/become_a_customer',
    ),
);
const BecomeAStylist = lazy(() =>
    lazyRetry(
        () => import('containers/authentication/SignUp/become_a_stylist'),
        'containers/authentication/SignUp/become_a_stylist',
    ),
);
const Signup = lazy(() =>
    lazyRetry(() => import('containers/authentication/SignUp/Signup'), 'containers/authentication/SignUp/Signup'),
);
const CartPage = lazy(() => lazyRetry(() => import('containers/cart/CartPage'), 'containers/cart/CartPage'));
const CheckoutPage = lazy(() =>
    lazyRetry(() => import('containers/checkout/CheckoutPage'), 'containers/checkout/CheckoutPage'),
);

const AddCreateStyleItem = lazy(() =>
    lazyRetry(() => import('containers/create-style/AddCreateStyleItem'), 'containers/create-style/AddCreateStyleItem'),
);
const CreateStyleCanvas = lazy(() =>
    lazyRetry(() => import('containers/create-style/CreateStyleCanvas'), 'containers/create-style/CreateStyleCanvas'),
);
const CreateStylePublish = lazy(() =>
    lazyRetry(() => import('containers/create-style/CreateStylePublish'), 'containers/create-style/CreateStylePublish'),
);
const StyleInformation = lazy(() =>
    lazyRetry(() => import('containers/create-style/StyleInformation'), 'containers/create-style/StyleInformation'),
);

const CustomerStyleGuide = lazy(() =>
    lazyRetry(() => import('containers/customer_style_guide/index'), 'containers/customer_style_guide/index'),
);

const DashboardStylist = lazy(() =>
    lazyRetry(() => import('containers/dashboards/stylist/index'), 'containers/dashboards/stylist/index'),
);
const HomeWaiting = lazy(() =>
    lazyRetry(() => import('containers/homeScreen/home_waiting/index'), 'containers/homeScreen/home_waiting/index'),
);
const MyItemsScreen = lazy(() =>
    lazyRetry(
        () => import('containers/my_styles_my_items/my_items_screen'),
        'containers/my_styles_my_items/my_items_screen',
    ),
);
const MyStylesScreen = lazy(() =>
    lazyRetry(
        () => import('containers/my_styles_my_items/my_styles_screen'),
        'containers/my_styles_my_items/my_styles_screen',
    ),
);
const OderListing = lazy(() =>
    lazyRetry(() => import('containers/oder_listing/index'), 'containers/oder_listing/index'),
);

const OrderDetail = lazy(() =>
    lazyRetry(() => import('containers/order_detail/index'), 'containers/order_detail/index'),
);
const ResultPage = lazy(() =>
    lazyRetry(() => import('containers/payments/ResultPage'), 'containers/payments/ResultPage'),
);
const StylesRequestContainer = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/personas/style_request'),
        'containers/quiz_manager/personas/style_request',
    ),
);
const StylistManual = lazy(() =>
    lazyRetry(
        () => import('containers/sidebar_content/stylist_manual/stylist_manual'),
        'containers/sidebar_content/stylist_manual/stylist_manual',
    ),
);

const SuggestionScreens = lazy(() =>
    lazyRetry(() => import('containers/suggestion/index'), 'containers/suggestion/index'),
);
const userReactions = lazy(() =>
    lazyRetry(() => import('containers/user_reactions/index'), 'containers/user_reactions/index'),
);
const StyleQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/style_quiz/style_quiz'),
        'containers/quiz_manager/style_quiz/style_quiz',
    ),
);
const BudgetQuiz = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/budget_quiz'), 'containers/quiz_manager/budget_quiz'),
);

const BodyShapeQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/body_shape_body_type/body_shape_quiz'),
        'containers/quiz_manager/body_shape_body_type/body_shape_quiz',
    ),
);
const BodyTypeQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/body_shape_body_type/body_type_quiz'),
        'containers/quiz_manager/body_shape_body_type/body_type_quiz',
    ),
);
const MyPhotos = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/my_photos/my_photos'),
        'contcontainers/quiz_manager/my_photos/my_photos',
    ),
);

const MyBirthDayQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/my_birthday/my_birthday'),
        'containers/quiz_manager/my_birthday/my_birthday',
    ),
);
const SkinTone = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/color_list_multi/skin_tone'),
        'containers/quiz_manager/color_list_multi/skin_tone',
    ),
);
const SocialMediaQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/social_media/social_media'),
        'containers/quiz_manager/social_media/social_media',
    ),
);

const ColorsQuiz = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/color_quiz/color_quiz'),
        'containers/quiz_manager/color_quiz/color_quiz',
    ),
);
const Pattern = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/pattern_quiz/index'), 'containers/quiz_manager/pattern_quiz/index'),
);

const SkinUndertone = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/skin_undertone/SkinUndertone'),
        'containers/quiz_manager/skin_undertone/SkinUndertone',
    ),
);

const FashionRestriction = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/fashion_restriction/index'),
        'containers/quiz_manager/fashion_restriction/index',
    ),
);

const HijabQuiz = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/hijab/HijabQuiz'), 'containers/quiz_manager/hijab/HijabQuiz'),
);

const ChatScreen = lazy(() => lazyRetry(() => import('containers/chat/index'), 'containers/chat/index'));

const HairColor = lazy(() =>
    lazyRetry(
        () => import('containers/quiz_manager/hair_color/HairColor'),
        'containers/quiz_manager/hair_color/HairColor',
    ),
);
const SizesQuiz = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/size_list/sizes'), 'containers/quiz_manager/size_list/sizes'),
);

const EyeColor = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/eye_color/EyeColor'), 'containers/quiz_manager/eye_color/EyeColor'),
);

const MeasurementsQuiz = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/measurements/index'), 'containers/quiz_manager/measurements/index'),
);

const ShowOff = lazy(() =>
    lazyRetry(() => import('containers/quiz_manager/show_off'), 'containers/quiz_manager/show_off'),
);

const Cover = lazy(() => lazyRetry(() => import('containers/quiz_manager/cover'), 'containers/quiz_manager/cover'));

const VerifyCalendly = lazy(() =>
    lazyRetry(
        () => import('containers/connected_accounts/calendly/verify_calendly'),
        'containers/connected_accounts/calendly/verify_calendly',
    ),
);
const CalendlyMeetings = lazy(() =>
    lazyRetry(
        () => import('containers/connected_accounts/calendly/calendly_meetings'),
        'containers/connected_accounts/calendly/calendly_meetings',
    ),
);
const RedirectToMyOrder = lazy(() =>
    lazyRetry(() => import('containers/redirects/RedirectToMyOrder'), 'containers/redirects/RedirectToMyOrder'),
);
const RedirectToStyleGuide = lazy(() =>
    lazyRetry(() => import('containers/redirects/RedirectToStyleGuide'), 'containers/redirects/RedirectToStyleGuide'),
);

const MyWardrobe = lazy(() =>
    lazyRetry(() => import('containers/profile_customer/MyWardrobe'), 'containers/profile_customer/MyWardrobe'),
);

const ViewConsumerProfile = lazy(() =>
    lazyRetry(
        () => import('containers/profile_customer/view_profile_customer/view_consumer_profile'),
        'containers/profile_customer/view_profile_customer/view_consumer_profile',
    ),
);

const SessionStylistNotes = lazy(() =>
    lazyRetry(
        () => import('containers/session_details/StylistNotes/index'),
        'containers/session_details/StylistNotes/index',
    ),
);
const RequestQuizManager = lazy(() =>
    lazyRetry(() => import('containers/session_quiz/index'), 'containers/session_quiz/index'),
);

const StyleReview = lazy(() =>
    lazyRetry(() => import('containers/style_review/index'), 'containers/style_review/index'),
);

const StyleList = lazy(() => lazyRetry(() => import('containers/style_list/index'), 'containers/style_list/index'));
const FatenUnlistedReviewed = lazy(() =>
    lazyRetry(
        () => import('containers/style_list/faten_unlisted_reviewed'),
        'containers/style_list/faten_unlisted_reviewed',
    ),
);

export const PATH_GLOBAL = [
    {
        path: PATH.FORGOT_PASSWORD,
        component: ForgotPass,
        exact: false,
    },
    {
        path: PATH.RESET_PASSWORD_SUCCESS,
        component: ResetPasswordSuccess,
        exact: false,
    },
    {
        path: PATH.LOGIN,
        component: Login,
        exact: true,
    },
    {
        path: PATH.LOGOUT,
        component: Logout,
        exact: true,
    },
    {
        path: PATH.WIDGET,
        component: Widget,
        exact: true,
    },
    {
        path: PATH.LOGIN_WITH_EMAIL,
        component: LoginWithEmail,
        exact: false,
    },
    {
        path: PATH.ADDITIONAL_SIGNUP_DETAILS,
        component: AdditionalSignupDetails,
        exact: false,
    },
    {
        path: PATH.SIGNUP_CUSTOMER,
        component: Signup,
        exact: true,
    },
    {
        path: PATH.SIGNUP_CUSTOMER_WITH_EMAIL,
        component: BecomeACustomer,
        exact: false,
    },
    {
        path: PATH.SIGNUP_STYLIST,
        component: BecomeAStylist,
        exact: false,
    },
    {
        path: PATH.HOME_WAITING,
        component: HomeWaiting,
        exact: false,
    },
    {
        path: PATH.FLOWARD,
        component: GiftCardOnboardStartPage,
        isExact: true,
    },
];

export const PATH_CUSTOMER = [
    {
        path: PATH.STYLE_QUIZ,
        component: StyleQuiz,
        exact: false,
    },
    {
        path: PATH.BUDGET_QUIZ,
        component: BudgetQuiz,
        isExact: false,
    },
    {
        path: PATH.FEED,
        component: RecommendStylePage,
        isExact: false,
    },
    {
        path: PATH.SEARCH_STYLES,
        component: SearchStylePage,
        isExact: false,
    },
    {
        path: PATH.LIST_STYLES,
        component: StyleList,
        isExact: false,
    },
    {
        path: PATH.FATEN_UNLISTED_REVIEWED,
        component: FatenUnlistedReviewed,
        isExact: false,
    },
    {
        path: PATH.HIGHLIGHT,
        component: HighlightPage,
        isExact: false,
    },
    {
        path: PATH.QUIZ_MANAGER,
        component: QuizManager,
        isExact: false,
    },
    {
        path: PATH.QUIZ_PERSONAS,
        component: StylesRequestContainer,
        isExact: false,
    },
    {
        path: PATH.BODY_SHAPE_QUIZ,
        component: BodyShapeQuiz,
        isExact: false,
    },
    {
        path: PATH.BODY_TYPE_QUIZ,
        component: BodyTypeQuiz,
        isExact: false,
    },
    {
        path: PATH.MY_BIRTHDAY_QUIZ,
        component: MyBirthDayQuiz,
        isExact: false,
    },
    {
        path: PATH.SKIN_TONE,
        component: SkinTone,
        isExact: false,
    },
    {
        path: PATH.SOCIAL_MEDIAS,
        component: SocialMediaQuiz,
        isExact: false,
    },
    {
        path: PATH.COLOR_QUIZ,
        component: ColorsQuiz,
        isExact: false,
    },
    {
        path: PATH.PATTERN_QUIZ,
        component: Pattern,
        isExact: false,
    },
    {
        path: PATH.SKIN_UNDERTONE,
        component: SkinUndertone,
        isExact: false,
    },
    {
        path: PATH.HAIR_COLOR,
        component: HairColor,
        isExact: false,
    },
    {
        path: PATH.EYE_COLOR,
        component: EyeColor,
        isExact: false,
    },
    {
        path: PATH.MEASUREMENTS_QUIZ,
        component: MeasurementsQuiz,
    },
    {
        path: PATH.SHOW_OFF,
        component: ShowOff,
        isExact: false,
    },
    {
        path: PATH.SIZES_QUIZ,
        component: SizesQuiz,
        isExact: false,
    },
    {
        path: PATH.COVER,
        component: Cover,
        isExact: false,
    },
    {
        path: PATH.CHECKOUT,
        component: CheckoutPage,
        isExact: false,
    },
    {
        path: PATH.MY_PHOTOS,
        component: MyPhotos,
        isExact: false,
    },
    {
        path: PATH.ODER_LIST,
        component: OderListing,
        isExact: false,
    },
    {
        path: PATH.OLD_ORDER_LIST,
        component: RedirectToMyOrder,
        isExact: false,
    },
    {
        path: PATH.ODER_DETAIL + '/:orderTaffiId',
        component: OrderDetail,
        isExact: false,
    },
    {
        path: PATH.RESULT,
        component: ResultPage,
        isExact: false,
    },
    {
        path: PATH.USER_LIKES,
        component: userReactions,
        isExact: false,
    },
    {
        path: PATH.STYLE_GUIDE,
        component: CustomerStyleGuide,
        isExact: false,
    },
    {
        path: PATH.OLD_STYLE_GUIDE,
        component: RedirectToStyleGuide,
        isExact: false,
    },
    // REDIRECT STYLE REQUEST PHASE 1 ROUTES
    {
        path: PATH.SESSION_PURPOSE,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SESSION_PURPOSE} />,
        isExact: false,
    },
    {
        path: PATH.SESSION_INTRO,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SESSION_PURPOSE} />,
        isExact: false,
    },
    {
        path: PATH.SELECT_STYLIST,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SELECT_STYLIST} />,
        isExact: false,
    },
    {
        path: PATH.SESSION_STYLIST_DETAIL + '/:userName',
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.VIEW_STYLIST_DETAIL} />,
        isExact: false,
    },
    {
        path: PATH.SELECT_SCHEDULE_TIME,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SELECT_SCHEDULE_TIME} />,
        isExact: false,
    },
    {
        path: PATH.SESSION_SCHEDULED,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SESSION_SCHEDULED} />,
        isExact: false,
    },
    {
        path: PATH.REQUEST_SUCCESS,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.ORDER_SUCCESS} />,
        isExact: false,
    },
    {
        path: PATH.REVIEW_REQUEST,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.REVIEW_ORDER} />,
        isExact: false,
    },
    // REDIRECT OLD STYLE REQUEST ROUTES
    {
        path: PATH.OLD_SESSION_PURPOSE,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SESSION_PURPOSE} />,
        isExact: false,
    },
    {
        path: PATH.OLD_SELECT_STYLIST,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SELECT_STYLIST} />,
        isExact: false,
    },
    {
        path: PATH.OLD_REVIEW_REQUEST,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.REVIEW_ORDER} />,
        isExact: false,
    },
    {
        path: PATH.OLD_REQUEST_SUCCESS,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.ORDER_SUCCESS} />,
        isExact: false,
    },
    {
        path: PATH.OLD_SELECT_SCHEDULE_TIME,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SELECT_SCHEDULE_TIME} />,
        isExact: false,
    },
    {
        path: PATH.OLD_SESSION_SCHEDULED,
        component: () => <RedirectToStyleRequests newPath={SESSION_QUIZ_PATH.SESSION_SCHEDULED} />,
        isExact: false,
    },

    // OTHERS
    {
        path: PATH.STYLISTS,
        component: SearchStylistPage,
        isExact: false,
    },
    {
        path: PATH.PERSONALIZED_STYLES,
        component: RecommendStylePage,
        isExact: false,
    },
    {
        path: PATH.RELATED_STYLES + '/:itemTaffiId',
        component: ViewRelatedStyles,
        isExact: false,
    },
    {
        path: PATH.WARDROBE,
        component: MyWardrobe,
        isExact: false,
    },
    {
        path: PATH.USER_DISLIKES,
        component: userReactions,
        isExact: false,
    },
    {
        path: PATH.FASHION_RESTRICTION,
        component: FashionRestriction,
        isExact: false,
    },
    {
        path: PATH.HIJAB_QUIZ,
        component: HijabQuiz,
        isExact: false,
    },
    {
        path: PATH.STYLE_REQUEST_QUIZ,
        component: RequestQuizManager,
        isExact: false,
    },
];
export const PATH_ANONYMOUS = [
    {
        path: PATH.STYLE_ASSISTANT,
        component: ChatScreen,
        isExact: false,
    },
];

export const PATH_STYLIST = [
    {
        path: PATH.CREATE_STYLE_CANVAS,
        component: CreateStyleCanvas,
        isExact: false,
    },
    {
        path: `${PATH.EDIT_STYLE_CANVAS}/:taffiId`,
        component: CreateStyleCanvas,
        isExact: false,
    },
    {
        path: PATH.CREATE_STYLE,
        component: AddCreateStyleItem,
        isExact: false,
    },
    {
        path: PATH.CREATE_STYLE_PUBLISH,
        component: CreateStylePublish,
        isExact: false,
    },
    {
        path: PATH.STYLE_INFO,
        component: StyleInformation,
        isExact: false,
    },
    {
        path: PATH.MY_STYLES,
        component: MyStylesScreen,
        isExact: false,
    },
    {
        path: PATH.MY_ITEMS,
        component: MyItemsScreen,
        isExact: false,
    },
    {
        path: PATH.STYLIST_DASHBOARD,
        component: DashboardStylist,
        isExact: false,
    },
    {
        path: PATH.STYLE_SUGGESTIONS,
        component: SuggestionScreens,
        isExact: false,
    },
    {
        path: PATH.STYLIST_TUTORIAL,
        component: StylistManual,
        isExact: true,
    },
    {
        path: PATH.PROFILE + '/:userName',
        component: ViewConsumerProfile,
        isExact: false,
    },
    {
        path: PATH.CONNECTED_ACCOUNTS,
        component: ConnectedAccounts,
        isExact: false,
    },
    {
        path: PATH.VERIFY_CALENDLY,
        component: VerifyCalendly,
        isExact: false,
    },
    {
        path: PATH.CALENDLY_MEETINGS,
        component: CalendlyMeetings,
        isExact: false,
    },
    {
        path: PATH.OLD_CONNECTED_ACCOUNTS,
        component: RedirectToMyConnectedAccounts,
        isExact: false,
    },
    {
        path: PATH.SESSION_STYLIST_NOTES,
        component: SessionStylistNotes,
        isExact: false,
    },
    {
        path: PATH.STYLE_REVIEW,
        component: StyleReview,
        isExact: false,
    },
];

!config.removeCheckOut &&
    PATH_CUSTOMER.push({
        path: PATH.CART,
        component: CartPage,
        isExact: false,
    });
